// import {showErr} from "../message";
// import aegis from "../aegis";
import runApi from "../../api/run";
import {emitEvent} from "../../utils/eventBus/vueEvent";
import Events from "../events";
import {getQceitQuery} from "../../store/modules/ide";
import timer from '../timer'
import consoleStyle from '../../components/ide/consoleStyle'

const Base64 = require('js-base64').Base64;

// http://local-qceit.youth.qq.com/ide-edit?ip=4440&lang=c&problem_id=3&exam_tid=2&user_uid=be4783e9-4326-40b2-893a-99a4083365ea&exam_uid=1&exam_grade_uid=1&question_uid=1&question_code=1&question_score=20&timestamp=1621338526&token=8ae0476b01e1dc2fb10c3ad50223e544

const runner = {
  isHttp: false,
  context: null,
}

const init = (context, isHttp) => {
  if (context) {
    runner.context = context;
  }
  runner.isHttp = isHttp;
}

const isHttp = () => {
  return runner.isHttp;
}

const output = async ({ sessionId, addr }, query) => { // addr,
  const data = getQceitQuery(query, {
    sessionId, addr
  });
  console.log('-http--output:', addr);
  const res = await runApi.output(data)
  if (res.data && res.data.result) {
    res.data.result = consoleStyle.getOutput(res.data.result);
    emitEvent(Events.OUTPUT_CONSOLE, res.data)
  }
  if (res.data && res.data.error && !res.data.Exit) {
    emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getWarn(res.data.error) })
  }
  return res;
}

const timerOutput = async (data) => {
  if (!data || !data.sessionId) {
    return;
  }
  const res = await output(data, runner.context.$route.query);
  if (res.Code === 0) {
    if (res.data && res.data.Exit) {
      emitEvent(Events.RUN_CODE_STOPED, res.data)
      return;
    }
  }
  timer.setTimer(timerOutput, timer.timers.getOutput.time, timer.timers.getOutput.key, data);
}

const input = async ({sessionId, addr}, input, query) => {
  const data = getQceitQuery(query, {
    sessionId, input, addr
  });
  console.log('-http--output:', addr);
  const res = await runApi.input(data)
  emitEvent(Events.RUN_CODE_INPUT_RES, res)
}

const stop = async ({addr, runToken, sessionId}, query) => {
  const data = getQceitQuery(query, {
    addr, runToken, sessionId
  });
  console.log('-http--stop:', data);
  const res = await runApi.stop(data)
  emitEvent(Events.RUN_CODE_STOP_RES, res)
}

const run = async (code, query, language, isEdit) => {
  const data = getQceitQuery(query, {
    code: Base64.encode(code),
    language: language,
    cbip: true,
    isEdit,
  });
  const res = await runApi.run(data)
  emitEvent(Events.RUN_CODE_RUN_RES, res)
  if (res.Code === 0) {
    timer.setTimer(timerOutput, timer.timers.getOutput.time, timer.timers.getOutput.key, res.data);
  }
}

export default {
  init,
  isHttp,
  run,
  output,
  input,
  stop,
}
